import React from 'react';
import type { useCategoryFilterSort } from '@ui-rocco/hooks/use-category-filter-sort';
import type { SearchSuggestionGroup } from '@rocco/ui/search/view-models/search-suggestion';
import { MobileSearchPageRecentlySearched } from './MobileSearchPageRecentlySearched';
import { MobileSearchPageSuggestedGroups } from './MobileSearchPageSuggestedGroups';
import { SearchResultPageTilesGrid } from './SearchResultPageTilesGrid';
import type { useFetcher } from '@remix-run/react';

type MobileSearchPageView = 'results' | 'recentlySearched' | 'suggestions';

interface SearchPageContentSectionsMobileProps {
    view: MobileSearchPageView;
    filterSortProps: ReturnType<typeof useCategoryFilterSort>;
    suggestionGroups: SearchSuggestionGroup[];
    inputSearchQuery: string;
    fetcherState: ReturnType<typeof useFetcher>['state'];
    isLoading: boolean;
}

/**
 * Renders the content sections for the mobile view of the search page.
 * Switches between recently searched, suggestions, and results views.
 */
export const SearchPageContentSectionsMobile: React.FC<
    SearchPageContentSectionsMobileProps
> = ({
    view,
    filterSortProps,
    suggestionGroups,
    inputSearchQuery,
    fetcherState,
    isLoading,
}) => {
    return (
        <>
            {view === 'recentlySearched' && (
                <MobileSearchPageRecentlySearched />
            )}
            {view === 'suggestions' &&
                suggestionGroups[0] &&
                suggestionGroups
                    .filter((group) => group.options.length > 0)
                    .map((group) => (
                        <MobileSearchPageSuggestedGroups
                            key={group.type}
                            query={inputSearchQuery}
                            group={group}
                        />
                    ))}
            {view === 'results' && (
                <SearchResultPageTilesGrid
                    {...filterSortProps}
                    fetcherState={fetcherState}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
